import {Component, Inject, Input, OnInit} from '@angular/core';
import {UntilDestroy} from "@ngneat/until-destroy";
import {APP_ROUTES, AppRoutes} from "@config/app-routes.config";
import {OrderService} from "@modules/order/services/order.service";
import {CommonModule} from "@angular/common";
import {CheckoutPageComponent} from "@shared/component/payments/pages/checkout-page/checkout-page.component";
import {Job} from "@modules/job/models/job.model";

@UntilDestroy()
@Component({
  standalone: true,
  imports: [CommonModule, CheckoutPageComponent],
  selector: 'app-job-checkout[job]',
  templateUrl: './job-checkout.component.html',
  styleUrls: ['./job-checkout.component.scss'],
})
export class JobCheckoutComponent implements OnInit {
  @Input() job: Job
  @Input() shouldRedirect = true;
  redirectUrl: any[];

  get country() {
    return this.job?.supportedCountry?.country ?? null
  }

  constructor(
    @Inject(APP_ROUTES) private readonly appRoutes: AppRoutes,
    private readonly orderService: OrderService,
  ) {
  }

  ngOnInit(): void {
    if (this.job) {
      const { order, id } = this.job

      this.orderService.dispatchAddOrUpdateThenSelectEntityAction(order)

      this.orderService.setReturnUrl([window.location.origin, 'job', id].join('/'))

      this.redirectUrl = this.appRoutes.jobDetail(id)
    }
  }
}
